import {Card, FlexRow, styled} from "@reside/ui";
import {AdminLayout} from "../../atoms/admin-layout";

/** Matches `AdminLayout` `LayoutContent` max-width. */
export const ADMIN_CONTENT_MAX_WIDTH = 1280;

/** Centered content column shared by page headers, forms, and submenu. */
export const HubAndSpokePageBody = styled.div`
  width: 100%;
  max-width: ${ADMIN_CONTENT_MAX_WIDTH}px;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
`;

/** Title row aligned with the rest of the admin app (max-width 1280px, centered). */
export const HubAndSpokePageHeader = styled(FlexRow)`
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${({theme}) => theme.space[4]}px;
  width: 100%;
  max-width: ${ADMIN_CONTENT_MAX_WIDTH}px;
  margin: 0 auto ${({theme}) => theme.space[4]}px;
  box-sizing: border-box;
`;

export const FormWrapper = styled(HubAndSpokePageBody)`
  position: relative;
`;

export const TemplateFieldRow = styled.div`
  display: flex;
  width: 100%;
  align-items: bottom;
  margin: ${({theme}) => theme.space[2]}px 0;

  label {
    width: 100%;
  }
`;

export const TemplateFieldCard = styled.div`
  border-bottom: ${({theme}) => `1px solid ${theme.color.gray5}`};
  margin: ${({theme}) => theme.space[2]}px 0;
  padding: ${({theme}) => theme.space[2]}px;
`;

export const StyledCard = styled(Card)`
  padding-top: ${({theme}) => theme.space[6]}px;
  margin: ${({theme}) => theme.space[4]}px 0;
`;

export const PageWrapper = styled(Card)`
  padding: ${({theme}) => theme.space[4]}px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: right;
  gap: ${({theme}) => theme.space[4]}px;
`;

/** Break table scroll out of the centered AdminLayout max-width (matches dashboard list). */
export const ListTableBleed = styled.div`
  width: 100vw;
  margin-left: calc(50% - 50vw);
  /* Clearance for the fixed horizontal scroll minimap at the bottom of the viewport. */
  padding-bottom: 40px;
`;

/** Positioning context for the horizontal scroll minimap. */
export const ListTableScrollShell = styled.div`
  position: relative;
  width: 100%;
`;

export const ListTableScrollInner = styled.div`
  width: max-content;
  min-width: 100%;
  /* Align first column with AdminLayout content (max-width 1280px, centered). */
  padding-left: max(
    0px,
    calc((100vw - ${ADMIN_CONTENT_MAX_WIDTH}px) / 2)
  );
  padding-right: ${({theme}) => theme.space[4]}px;

  @media (max-width: 1170px) {
    padding-left: 15px;
    padding-right: 15px;
  }

  @media (max-width: 768px) {
    padding-left: 10px;
    padding-right: 10px;
  }

  @media (max-width: 460px) {
    padding-left: 7px;
    padding-right: 7px;
  }

  .lt-clip,
  .list-table {
    width: max-content;
    min-width: 100%;
  }
`;

export const Layout = styled(AdminLayout)`
  padding-top: 80px;
`;
